export let Steps;
(function (Steps) {
  Steps["LANDING_PAGE"] = "LANDING_PAGE";
  Steps["AD"] = "AD";
  Steps["AD_WITHOUT_CAMPAIGN_ACCESS"] = "AD_WITHOUT_CAMPAIGN_ACCESS";
})(Steps || (Steps = {}));
export const DISCOVERY_MODE_GROUP_KEY = 'discovery-mode-mvp-lead-generation';
export const DISCOVERY_MODE_ONBOARDING_REFERRER_SOURCE = 'discovery_lead_gen';
export const DISCOVERY_MODE_LANDING_PAGE_TASK_KEY = 'add-form-landing-page-discovery-mode-experiment';
export const DISCOVERY_MODE_LANDING_PAGE_TASK_ID_QA = '537529';
export const DISCOVERY_MODE_LANDING_PAGE_TASK_ID_PROD = '337218';
export const DISCOVERY_MODE_ADS_TASK_KEY = 'promote-landing-page-discovery-mode-experiment';
export const DISCOVERY_MODE_ADS_TASK_ID_QA = '537531';
export const DISCOVERY_MODE_ADS_TASK_ID_PROD = '337219';
export let CurrentTask;
(function (CurrentTask) {
  CurrentTask["ADD_FORM"] = "ADD_FORM";
  CurrentTask["ADD_LANDING_PAGE"] = "ADD_LANDING_PAGE";
  CurrentTask["ADD_GOOGLE_ADS"] = "ADD_GOOGLE_ADS";
  CurrentTask["ADD_CAMPAIGN"] = "ADD_CAMPAIGN";
})(CurrentTask || (CurrentTask = {}));
export const DISCOVERY_MODE_ONBOARDING_TOUR_ID = 'discoveryTour';